import { RootState } from "app/services/store";
import { storeAuthorisationToken } from "app/store/slices/authorisation";
import {
  finishedLoadingToken,
  setTokenRestored,
} from "app/store/slices/overlay";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchToken } from "ui/utils/ManageTokens";

export function useLoadToken() {
  const token = useSelector(
    (state: RootState) => state.authorisation.auth?.token,
  );

  const dispatch = useDispatch();

  const finishedLoading = () => {
    dispatch(finishedLoadingToken());
  };

  const loadToken = useCallback(
    async (onComplete: (hasToken: boolean) => void) => {
      if (token) {
        finishedLoading();
        dispatch(setTokenRestored(true));
        onComplete(true);
        return;
      }

      const auth = await fetchToken();
      if (auth) {
        dispatch(storeAuthorisationToken(auth));
        dispatch(setTokenRestored(true)); // ✅ token restored
        onComplete(true);
      } else {
        onComplete(false);
      }
      finishedLoading();
    },
    [dispatch, token],
  );

  return { loadToken, token };
}
